import { render } from "./HeaderView.vue?vue&type=template&id=b6e8d928&scoped=true"
import script from "./HeaderView.vue?vue&type=script&lang=js"
export * from "./HeaderView.vue?vue&type=script&lang=js"

import "./HeaderView.vue?vue&type=style&index=0&id=b6e8d928&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6e8d928"]])

export default __exports__